
    import { mapActions, mapGetters } from "vuex"
    import { defineComponent } from "vue"
    import Prompt from "@/components/prompts/Prompt.vue"
    import TheHeader from "@/components/TheHeader.vue"
    import Breadcrumbs, { IBreadcrumb } from "@/components/misc/Breadcrumbs.vue"
    import { ICategory, IPrompt } from "@/types"

    export default defineComponent({
        components: {
            Breadcrumbs,
            TheHeader,
            Prompt,

        },
        data() {
            return {
                prompt: null as IPrompt | null,

            }
        },
        computed: {
            breadcrumbs(): IBreadcrumb[] {
                const category = this.categories?.find((category: ICategory) => category.id === this.prompt?.categories_ids[0])
                return [
                    { name: "Main", link: "/" },
                    category && { name: category.name, link: "/category/" + category.id },
                    { name: this.prompt?.name, link: "#" },
                ].filter(Boolean)
            },

            ...mapGetters(["prompts", "categories"]),

        },
        methods: {
            ...mapActions(["getPrompt", "getCategories"]),

        },

        async created () {
            await this.getPrompt(this.$route.params.prompt)
            this.getCategories()
            this.prompt = this.prompts[0]
            document.title = "GPT Craft - " + this.prompt?.name
        },
    })

    